import { useCallback, useState } from 'react';

const useArticleModalUiState = () => {
  const [kpiaModalOpen, setKpiaModalOpen] = useState(false);
  const [highlightEnabled, setHighlightEnabled] = useState(false);
  const [moreMenuAnchor, setMoreMenuAnchor] = useState(null);
  const [sentimentAnchor, setSentimentAnchor] = useState(null);
  const [exposureAnchor, setExposureAnchor] = useState(null);

  const openKpiaModal = useCallback(() => {
    setKpiaModalOpen(true);
  }, []);

  const closeKpiaModal = useCallback(() => {
    setKpiaModalOpen(false);
  }, []);

  const toggleHighlight = useCallback(() => {
    setHighlightEnabled(prev => !prev);
  }, []);

  const openMoreMenu = useCallback((event) => {
    setMoreMenuAnchor(event.currentTarget);
  }, []);

  const closeMoreMenu = useCallback(() => {
    setMoreMenuAnchor(null);
  }, []);

  const openSentimentMenu = useCallback((event) => {
    setSentimentAnchor(event.currentTarget);
  }, []);

  const closeSentimentMenu = useCallback(() => {
    setSentimentAnchor(null);
  }, []);

  const openExposureMenu = useCallback((event) => {
    setExposureAnchor(event.currentTarget);
  }, []);

  const closeExposureMenu = useCallback(() => {
    setExposureAnchor(null);
  }, []);

  const closeAnalysisMenus = useCallback(() => {
    setExposureAnchor(null);
    setSentimentAnchor(null);
    setMoreMenuAnchor(null);
  }, []);

  return {
    closeAnalysisMenus,
    closeExposureMenu,
    closeKpiaModal,
    closeMoreMenu,
    closeSentimentMenu,
    exposureAnchor,
    highlightEnabled,
    kpiaModalOpen,
    moreMenuAnchor,
    openExposureMenu,
    openKpiaModal,
    openMoreMenu,
    openSentimentMenu,
    sentimentAnchor,
    showBriefingHighlights: true,
    setKpiaModalOpen,
    toggleHighlight
  };
};

export default useArticleModalUiState;
